var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-item mt-5"},[_vm._v("Campaign name")]),_c('el-input',{attrs:{"maxlength":"50","show-word-limit":"","placeholder":"My campaign..."},model:{value:(_vm.request.campaignName),callback:function ($$v) {_vm.$set(_vm.request, "campaignName", $$v)},expression:"request.campaignName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }